// VersionWatcher — zistí keď je nasadená nová verzia Matrixu a ponúkne obnoviť.
// Rieši „vidím starú verziu" — užívateľ nemusí ručne hard-reloadovať.
// p95 (ústava 67.15, Mirko 21. 9. 2026: „toto sa nemôže nikdy viac stať"): karta, ktorá beží so starou verziou,
// NEODOŠLE doklad — okno Odoslať pred odoslaním volá skontrolujVerziu(). Karta sa porovnáva so SVOJÍM balíkom.
import React, { useState, useEffect } from 'react'

const sledovatelia = new Set()
let referencia = null      // balík, s ktorým táto karta beží
let zastarana = false

function vlastnyBalik() {
  try {
    const s = [...document.querySelectorAll('script[src]')].map(x => x.getAttribute('src') || '').find(x => /assets\/index-[\w-]+\.js/.test(x))
    const m = s && s.match(/assets\/index-[\w-]+\.js/)
    return m ? m[0] : null
  } catch (_) { return null }
}

// true = karta beží s aktuálnou verziou (alebo sa to nedá zistiť); false = medzitým bola nasadená nová.
export async function skontrolujVerziu() {
  try {
    const r = await fetch('/v2/index.html?_=' + Date.now(), { cache: 'no-store' })
    if (!r.ok) return !zastarana
    const html = await r.text()
    const m = html.match(/assets\/index-[\w-]+\.js/)
    const hash = m ? m[0] : null
    if (!hash) return !zastarana
    if (referencia === null) referencia = vlastnyBalik() || hash
    if (hash !== referencia && !zastarana) {
      zastarana = true
      sledovatelia.forEach(fn => { try { fn(true) } catch (_) {} })
    }
  } catch (_) {}
  return !zastarana
}

export default function VersionWatcher() {
  const [stale, setStale] = useState(zastarana)
  useEffect(() => {
    sledovatelia.add(setStale)
    skontrolujVerziu()
    const iv = setInterval(skontrolujVerziu, 60000)            // každú minútu
    const onFocus = () => { skontrolujVerziu() }               // + pri návrate do tabu
    window.addEventListener('focus', onFocus)
    return () => { sledovatelia.delete(setStale); clearInterval(iv); window.removeEventListener('focus', onFocus) }
  }, [])
  if (!stale) return null
  return (
    <div style={{ position: 'fixed', bottom: 18, left: 18, zIndex: 99999, background: '#15803d', color: '#fff', padding: '12px 18px', borderRadius: 10, boxShadow: '0 8px 28px rgba(0,0,0,0.28)', display: 'flex', alignItems: 'center', gap: 14, fontFamily: 'inherit', fontSize: 14, fontWeight: 700, maxWidth: 'calc(100vw - 36px)' }}>
      <span>Nová verzia Matrixu je nasadená<span style={{ display: 'block', fontWeight: 500, fontSize: 12.5, opacity: 0.92 }}>Kým stránku neobnovíš, doklady sa z tejto karty neodošlú.</span></span>
      <button onClick={() => window.location.reload()} style={{ background: '#fff', color: '#15803d', border: 'none', borderRadius: 7, padding: '7px 16px', fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' }}>Obnoviť teraz</button>
    </div>
  )
}
